var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.areProTriggersUsed)?_c('ProOnlyAlertBox',{staticClass:"mb-5 mt-6",attrs:{"options":{
    feature: 'popups',
    content: `Get ${_vm.$bdox(
      'plugin_name'
    )} Pro to get access to all popup triggers.`
  }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }